import axios from 'axios'
import { MAIN_API } from './apiUrl'

const documentNotificationsApi = {
  getCounts () {
    return new Promise((resolve, reject) => {
      axios({
        url: MAIN_API + '/api/document-notifications/counts',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        },
        method: 'GET'
      }).then(response => {
        resolve(response.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  markAsRead (docTypes) {
    return new Promise((resolve, reject) => {
      axios({
        url: MAIN_API + '/api/document-notifications/read',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        },
        data: { docTypes },
        method: 'POST'
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default documentNotificationsApi
